
  module.exports =
  {
    live: require('./ONT/search'),
    notLive: require('./ONT/search'),
    plots: require('./ONT/plots'),
  }